
document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("quoteModal");

  if (!modal) return;

  const closeButton = modal.querySelector(".quote-close");

  const dialog = modal.querySelector(".quote-modal-content");

  const messageField = modal.querySelector("#quote-message");

  const productField = modal.querySelector("#quote-product");

  const skuField = modal.querySelector("#quote-product-sku");

  const urlField = modal.querySelector("#quote-product-url");

  let previousFocus = null;

  let previousOverflow = "";

  /* =====================================
     OPEN POPUP
  ===================================== */

  function openQuoteModal(productTitle, productSKU, productURL) {

    if (productField) {
      productField.value = productTitle || "";
    }

    if (skuField) {
      skuField.value = productSKU || "";
    }

    if (urlField) {
      urlField.value = productURL || "";
    }

    if (messageField) {

      messageField.value =
        "Interested in: " +
        (productTitle || "") +
        (productSKU ? " with SKU " + productSKU : "");

    }

    previousFocus = document.activeElement;

    previousOverflow = document.body.style.overflow;

    modal.style.display = "flex";

    modal.setAttribute("aria-hidden", "false");

    document.body.classList.add("quote-modal-open");

    document.body.style.overflow = "hidden";

    const firstInput = modal.querySelector(
      'input[name="contact[name]"]'
    );

    (firstInput || dialog)?.focus();

  }

  /* =====================================
     CLOSE POPUP
  ===================================== */

  function closeQuoteModal() {

    modal.style.display = "none";

    modal.setAttribute("aria-hidden", "true");

    document.body.classList.remove("quote-modal-open");

    document.body.style.overflow = previousOverflow;

    if (previousFocus && previousFocus.isConnected) {
      previousFocus.focus();
    }

  }

  /* =====================================
     REQUEST PRICING BUTTON
  ===================================== */

  document.addEventListener("click", function (event) {

    const button = event.target.closest(
      "[data-request-quote]"
    );

    if (!button) return;

    event.preventDefault();

    const productTitle =
      button.dataset.productTitle || "";

    const productSKU =
      button.dataset.productSku || "";

    const productURL =
      button.dataset.productUrl || "";

    openQuoteModal(
      productTitle,
      productSKU,
      productURL
    );

  });

  /* =====================================
     CLOSE BUTTON
  ===================================== */

  closeButton?.addEventListener(
    "click",
    closeQuoteModal
  );

  /* =====================================
     CLOSE WHEN CLICKING OUTSIDE
  ===================================== */

  modal.addEventListener("click", function (event) {

    if (event.target === modal) {
      closeQuoteModal();
    }

  });

  /* =====================================
     ESCAPE KEY
  ===================================== */

  document.addEventListener("keydown", function (event) {

    if (
      event.key === "Escape" &&
      modal.style.display === "flex"
    ) {
      closeQuoteModal();
    }

  });

  /* =====================================
     REOPEN AFTER FORM SUBMISSION
  ===================================== */

  const form = modal.querySelector("form");

  if (
    form &&
    (
      modal.querySelector(".quote-success") ||
      modal.querySelector(".quote-errors")
    )
  ) {

    previousOverflow = document.body.style.overflow;

    modal.style.display = "flex";

    modal.setAttribute("aria-hidden", "false");

    document.body.classList.add("quote-modal-open");

    document.body.style.overflow = "hidden";

    dialog?.focus();

  }

});